import {
    ColorBrandBlue1,
    ColorNeutralBlack,
    ColorNeutralGrey3,
    ColorNeutralGrey5,
    ColorNeutralLightGrey,
    ColorNeutralWhite
} from 'autogen/design-tokens/tokens';

type ColorPallet = {
    borderColor: string;
    fontColor: string;
    backgroundColor?: string;
    checked: {
        borderColor?: string;
        fontColor?: string;
        backgroundColor?: string;
    };
    disabled: {
        borderColor?: string;
        fontColor?: string;
        backgroundColor?: string;
    };
};

const primaryOutline: ColorPallet = {
    borderColor: ColorNeutralLightGrey,
    fontColor: ColorNeutralBlack,
    checked: {
        borderColor: ColorBrandBlue1
    },
    disabled: {
        borderColor: ColorNeutralGrey3,
        fontColor: ColorNeutralLightGrey
    }
};

const primaryFilled: ColorPallet = {
    ...{ ...primaryOutline, backgroundColor: ColorNeutralWhite }
};

const lightOutline: ColorPallet = {
    borderColor: ColorNeutralLightGrey,
    fontColor: ColorNeutralWhite,
    checked: {
        borderColor: ColorNeutralGrey3
    },
    disabled: {
        borderColor: ColorNeutralGrey3,
        fontColor: ColorNeutralLightGrey
    }
};

export const chipVariants = {
    primaryOutline,
    primaryFilled,
    lightOutline
} as const;

export type ChipVariantKeys = keyof typeof chipVariants;
